import React from 'react';
import { UserOutlined } from '@ant-design/icons';
import UserMenu from '../UserMenu';
import { connect } from 'react-redux';
import { Tabs } from 'antd';
import Base from '../Base';
import BillingData from './BillingData';
const { TabPane } = Tabs;

function UserProfile(props) {    
        return (
            <Base>
                <h1 className="title-text blue-text">Perfil de usuario</h1>
                <Tabs defaultActiveKey={1} size="medium" destroyInactiveTabPane>
                    <TabPane tab="Datos de Facturación" key="1"  >
                        <BillingData />
                    </TabPane>
                </Tabs> 
            </Base>			
        )
    }

export default UserProfile
